var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"user-info-page",attrs:{"id":"user-info-page-container"}},[_c('c-banner-user-info'),_c('c-sub-section-info'),_c('c-rules-section-info')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }